// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"12":"e918cf3bc4c5e6bd","94":"a30c541ad8929bfd","631":"5be9c21562a9d5ae","713":"2f2733466de8be14"}[chunkId] + ".js";
};